import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL } from '../constants'
import BusinessCreate from '../features/business_create'
import BusinessPreview from '../components/previews/business_preview'
import ColumnIndicator from '../components/column_indicator'
import { me, meBusinesses } from '../initial_state'
import { fetchBusinessById } from '../actions/businesses'

class BusinessEditPage extends React.PureComponent {

  componentDidMount() {
    const { business, onFetchBusinessById, businessId } = this.props

    if (!business) onFetchBusinessById(businessId)
  }

  render() {
    const { isXS, businessId, isOwner} = this.props
    
    const title = 'Edit Business'

    const actions = [
      // {
      //   title: 'Save',
      //   onClick: () => {},
      // },
    ]

    return (
      <DefaultLayout
        noRightSidebar
        showBackBtn
        title={title}
        page='business-create'
        noPullToRefresh
        actions={actions}
        sidebarChildren={!isXS && isOwner ? <BusinessCreate isEditing id={businessId} /> : <div /> }
      >
        <PageTitle path={title} />

        {(!isXS && isOwner) && <BusinessPreview />}
        
        {
          isXS && isOwner &&
          <div className={[_s.d, _s.w100PC, _s.bgPrimary, _s.px15].join(' ')}>
            <BusinessCreate isEditing id={businessId} />
          </div>
        }
      </DefaultLayout>
    )
  }

}


const mapStateToProps = (state, { params: { businessId }}) => {
  const businessAccount = state.getIn(['businesses', 'business_accounts', businessId])
  const isOwner = !!businessAccount ?
    businessAccount.get('account_id') === me && businessAccount.get('role') === 'owner' : 
    Array.isArray(meBusinesses) && meBusinesses.indexOf(businessId) > -1
    
  return {
    isOwner,
    businessId,
    businessAccount,
    business: state.getIn(['businesses', 'items', businessId]),
    isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetchBusinessById(id) {
    dispatch(fetchBusinessById(id))
  },
})

BusinessEditPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessEditPage)